<template>
    <div id="MainContainer">

        <div id="FormContainer" class="col-sm-8 col-md-4">
            <form>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="button-addon-id">
                            <span v-if="searching">
                                Searching
                                <span class="spinner-border spinner-border-sm ml-1" role="status"
                                    aria-hidden="true"></span>
                            </span>
                            <span v-else>Search</span>
                        </span>
                    </div>
                    <input type="text" class="form-control" placeholder="Certificate ID" v-model="id"
                        aria-label="Certificate ID" aria-describedby="button-addon-id">
                    <div class="input-group-append">
                        <button @click.prevent="searchId" class="btn btn-outline-secondary">
                            <i class="fa fa-search" id="button-addon-id"></i>
                        </button>
                    </div>
                </div>

                <b-alert v-model="errSearch" variant="danger" dismissible>
                    {{ errMsg }}
                </b-alert>

                <div class="row d-flex justify-content-center pt-4">
                    <div class="col">
                        <hr>
                    </div>
                    <div class="col-auto">OR</div>
                    <div class="col">
                        <hr>
                    </div>
                </div>

                <div class="input-group mb-3 mt-5">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="certificate-file-upload">
                            <span v-if="uploading">
                                Uploading
                                <span class="spinner-border spinner-border-sm ml-1" role="status"
                                    aria-hidden="true"></span>
                            </span>
                            <span v-else>
                                Upload
                            </span>

                        </span>
                    </div>
                    <div class="custom-file">
                        <input type="file" class="custom-file-input" id="file-upload"
                            aria-describedby="certificate-file-upload" @change="uploadFile($event)">
                        <label class="custom-file-label" for="file-upload">
                            Certificate file
                        </label>
                    </div>
                </div>

                 <b-alert v-model="errUpload" variant="danger" dismissible>
                    {{ errMsg }}
                </b-alert>
            </form>

        </div>
    </div>
</template>

<script>
    import certlib from '../../lib/Certificate';

    export default {
        data: function () {
            return {
                id: null,
                errMsg: null,
                errSearch: false,
                errUpload: false,
                searching: false,
                uploading: false
            }
        },
        methods: {
            showError: function (errMsg, errType) {
                switch (errType) {
                    case 'search':
                        this.errSearch = true;
                        break;
                    case 'upload':
                        this.errUpload = true;
                        break;
                }
                this.errMsg = errMsg;
            },
            searchId: async function () {
                if(!this.id) return this.showError('Please Provide a Certificate Id.', 'search');
                this.searching = true;
                try {
                    let certificate = await certlib.getCertificateById(this.id);
                    if(certificate) this.$router.push(`/certificate/${this.id}`);
                    else throw new Error('Certificate id does not exist.');
                }
                catch (error) {
                    this.showError(error.message || 'An unknown error occurred.', 'search');
                }
                this.searching = false;
            },
            uploadFile: async function (event) {
                let vm = this;
                let reader = new FileReader();

                // success reading file
                reader.onload = () => {
                    try {
                        let jsonData = JSON.parse(reader.result);
                        let certificateId = jsonData._id;
                        // Disabled localstorage set to fix issues on payload verification
                        // window.localStorage.setItem('certificate', reader.result);
                        vm.$router.push(`/certificate/${certificateId}`);
                    }
                    catch (error) {
                        vm.showError(error.message || 'An unknown error occurred.', 'upload');
                    }
                    vm.uploading = false;
                };

                // error reading file
                reader.onerror = () => {
                    vm.showError('Error reading file.', 'upload');
                    vm.uploading = false;
                };

                // read file
                let file = event.target.files[0];
                if(file) reader.readAsText(file);
                vm.uploading = true;
            }
        }
    }
</script>

<style scoped>
    #MainContainer {
        background-position: center;
        background-size: cover;
        background-image: url('./../../assets/K-Background.png');
        height: 100vh;
        width: 100vw;
    }

    #FormContainer {
        padding-top: 40vh;
        margin-left: 5vw;
    }

    @media only screen and (max-width: 600px) {
        #FormContainer {
            margin-left: 0;
        }
    }
</style>
